import { useCallback } from "react";

import moment from "moment";
import { useTranslation } from "react-i18next";
import DatePicker from "./DatePicker";
import type { DatePickerProps } from "./types";
import { Grid, Typography, styled } from "@mui/material";

import { MAIN_STYLES } from "@constants";

const TypographyTitle = styled(Typography)({
  color: "#111111",
  fontWeight: "700",
  fontSize: "16px",
  alignSelf: "center",
  padding: "0 10px",
});

interface Props {
  /**
   * Fires when the user completes a date range selection.
   * startDate / endDate are "YYYY-MM-DD" strings, or undefined when cleared.
   */
  onChange?: (
    startDate: string | undefined,
    endDate: string | undefined
  ) => void;
  menuPlacement?: "left" | "right";
}

const DateRangePickerCustom: React.FC<Props> = ({
  onChange,
  menuPlacement = "left",
}) => {
  const { t } = useTranslation();

  const handleOnChange: DatePickerProps["onChange"] = useCallback(
    (dateRange: [Date | null, Date | null]) => {
      if (!onChange) return;

      const [start, end] = dateRange;

      if (!start || !end) {
        onChange(undefined, undefined);
        return;
      }

      // Pass exact dates the user selected — do NOT expand to start/end of month
      onChange(
        moment(start).format("YYYY-MM-DD"),
        moment(end).format("YYYY-MM-DD")
      );
    },
    [onChange]
  );

  return (
    <Grid display={"flex"} flexDirection={"row"} alignItems={"center"}>
      <TypographyTitle sx={{ paddingBottom: 0 }}>
        {t("ota_detailed_analysis.period")}
      </TypographyTitle>
      <DatePicker
        closeDelay={300}
        highlightCol={MAIN_STYLES.mainPurple}
        defaultTitle={t("write_review_page.entire_period")}
        onChange={handleOnChange}
        menuPlacement={menuPlacement}
      />
    </Grid>
  );
};

export default DateRangePickerCustom;
